<style lang="less" scoped>

</style>

<template>
    <div class="el-tree-container">
        <el-checkbox v-if="showCheckAll" v-model="checkAllFlag" @change="updateAreaSel">全选</el-checkbox>
        <el-tree :data="treeData" ref="areaTree" show-checkbox node-key="areaNo" :defaultCheckedKeys="defaultCheckedKeys" :props="defaultProps" @check-change="updateSelAreas">
        </el-tree>
    </div>
</template>

<script>
    // updateSelAreaFun  回调方法
    export default {
        name: 'ZDAreaTree',
        props: ['selAreas','showCheckAll'],
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'areaName'
                },
                checkAllFlag: false,
                treeData: [],
                defaultCheckedKeys: [],
            }
        },
        methods: {
            // 获取地区
            getAreaListData() {
                let _ = this;
                _.$H.get(_, _.$A.area, {}).then(res => {
                    // 排序
                    let dateRes = res.data.data.content;
                    let sortDataRes = dateRes.sort(_.$U.compare('areaLevel'));
                    // 记录Index
                    let provinceIndexObj = {};
                    let proIndex = 0;
                    let tableData = [];
                    let checkCityNos = {};
                    // 已经选择的对象
                    _.selAreas.forEach(area => {
                        checkCityNos[area.parentAreaName + area.areaName] = 1;
                    });
                    sortDataRes.forEach(area => {
                        if (area.areaName !== '海外') {
                            if (area.areaLevel == '1') {
                                // 省份
                                let provinceObj = {
                                    areaName: area.areaName,
                                    areaNo: area.areaNo,
                                    areaLevel: area.areaLevel,
                                    children: [],
                                };
                                tableData.push(provinceObj);
                                provinceIndexObj[area.areaName] = proIndex;
                                proIndex++;
                            } else if (area.areaLevel == '2') {
                                let cityChecked = checkCityNos[area.parentAreaName + area.areaName];
                                if (cityChecked) {
                                    _.defaultCheckedKeys.push(area.areaNo);
                                }
                                // 市级
                                let cityObj = {
                                    areaName: area.areaName,
                                    areaNo: area.areaNo,
                                    areaLevel: area.areaLevel,
                                    parentAreaName: area.parentAreaName
                                };
                                let parentProvinceIndex = provinceIndexObj[area.parentAreaName];
                                tableData[parentProvinceIndex].children.push(cityObj);
                            }
                        }
                    });
                    _.treeData = tableData;
                })
            },
            // 更新选择的区域
            updateSelAreas() {
                let _ = this;
                let selCitys = [];
                let selAreas = this.$refs.areaTree.getCheckedNodes();
                selAreas.forEach(area => {
                    if (area.areaLevel == '2') {
                        selCitys.push(area);
                    }
                });
                this.checkAllFlag = false;
                if(selCitys.length == 389){
                    this.checkAllFlag = true;
                }
                this.$emit('updateSelAreaFun', selCitys);
            },
            // 更新区域的全选或者取消全选
            updateAreaSel(flag) {
                if (flag) {
                    this.setSelAll();
                    this.checkAllFlag = true;
                } else {
                    this.checkAllFlag = false;
                    this.clearSelAll();
                }
            },
            clearSelAll(){
                let _ = this;
                let dataAll = JSON.parse(JSON.stringify(this.treeData));
                this.treeData = [];
                this.defaultCheckedKeys = [];
                setTimeout(function(){
                    _.treeData = dataAll;
                    _.$emit('updateSelAreaFun', []);
                },50)
            },
            // 全选
            setSelAll() {
                let _ = this;
                _.$H.get(_, _.$A.area, {}).then(res => {
                    // 排序
                    let dateRes = res.data.data.content;
                    let sortDataRes = dateRes.sort(_.$U.compare('areaLevel'));
                    // 记录Index
                    let provinceIndexObj = {};
                    let proIndex = 0;
                    let tableData = [];
                    sortDataRes.forEach(area => {
                        if (area.areaName !== '海外') {
                            if (area.areaLevel == '1') {
                                // 省份
                                let provinceObj = {
                                    areaName: area.areaName,
                                    areaNo: area.areaNo,
                                    areaLevel: area.areaLevel,
                                    children: [],
                                };
                                tableData.push(provinceObj);
                                provinceIndexObj[area.areaName] = proIndex;
                                proIndex++;
                            } else if (area.areaLevel == '2') {
                                // 市级
                                let cityObj = {
                                    areaName: area.areaName,
                                    areaNo: area.areaNo,
                                    areaLevel: area.areaLevel,
                                    parentAreaName: area.parentAreaName
                                };
                                _.defaultCheckedKeys.push(area.areaNo);
                                let parentProvinceIndex = provinceIndexObj[area.parentAreaName];
                                tableData[parentProvinceIndex].children.push(cityObj);
                            }
                        }
                    });
                    _.treeData = tableData;
                })
            },
        },
        mounted() {
            this.getAreaListData();
            this.checkAllFlag = false;
            if(this.selAreas.length == 389){
                this.checkAllFlag = true;
            }
        }
    }
</script>